import { render, staticRenderFns } from "./ScoreGroupTab.vue?vue&type=template&id=01ce4e0f&scoped=true&"
import script from "./ScoreGroupTab.vue?vue&type=script&lang=js&"
export * from "./ScoreGroupTab.vue?vue&type=script&lang=js&"
import style0 from "./ScoreGroupTab.vue?vue&type=style&index=0&id=01ce4e0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ce4e0f",
  null
  
)

export default component.exports